module.exports = __webpack_public_path__ + "img/tedx_logo.3d9753f2.png";